import React from 'react';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

export default class TimePicker extends React.Component {
    static defaultProps = {
        value: '00:00:00'
    }

    getValue() {
        return this.time.value;
    }

    render() {
        const { value, onUpdate, ...rest } = this.props;
        return [
            <input
                {...rest}
                key="time"
                ref={node => this.time = node}
                type="time"
                step="1"
                className='form-control'
                onChange={() => {}}
                onBlur={() => onUpdate(this.getValue())}
            />,
        ];
    }
}
